import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../../Shared/Header/Default/Herader";
import Footer from "../../../Shared/Footer/Default/Footer";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import "./RpdLite.css";

// RPD Lite: a lightweight "loaddocument" launcher page.
// It mirrors the behaviour of the standalone RPD launcher HTML that is
// served when a protected document link is opened: show a loading
// indicator, ask the API to resolve/authorize the document, and then do a
// full-page redirect to whatever URL the API returns. If the browser has
// no connectivity, it defers to the existing NoInternet screen instead of
// attempting the call.
const RpdLite = ({ translationsMap: langTranslations }) => {
  let translationsMap = useSelector(
    (state) => state.languageTranslation.translationsMap
  );
  if (translationsMap && Object.keys(translationsMap).length === 0) {
    translationsMap = { ...langTranslations };
  }

  const { documentId } = useParams();
  const navigate = useNavigate();
  const idRef = useRef(Date.now());
  const [loading, setLoading] = useState(true);

  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }

  async function handleFallback() {
    try {
      const response = await fetch(window.location.origin, {
        mode: "no-cors",
      });
      if (!response.ok) {
        window.location.href = window.location.origin;
      }
    } catch (error) {
      console.error("RpdLite: fallback redirect failed:", error);
      window.location.href = window.location.origin;
    }
  }

  async function loadDocument() {
    const rpdInfo = {
      id: documentId,
      unique_id: idRef.current.toString(),
      email: "",
      recipientId: "",
      data: "",
      initialData: "",
      remainingData: "",
      ip: "",
      client: getBrowserName(),
      fast_API: false,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/loaddocument/${documentId}`,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(rpdInfo),
        }
      );

      if (!response.ok && !response.redirected) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      window.open(response.url, "_self");
    } catch (error) {
      console.error("RpdLite: error loading document:", error);
      await handleFallback();
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!navigator.onLine) {
      navigate(`/Default/NoInternet/${documentId}`);
      return;
    }
    loadDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentId]);

  return (
    <div className="rpdFont">
      <Header
        Reader_ProtectedDocumentAccess={
          translationsMap.Reader_ProtectedDocumentAccess
        }
      ></Header>
      {loading && (
        <div className="spinerAuth-text">
          <LoadingSpinner
            authenticatingMsg={
              translationsMap.Reader_LoadingPleaseWait ||
              "Loading...Please wait..."
            }
          />
        </div>
      )}
      <Footer
        Reader_GeneralTermsFooter={translationsMap.Reader_GeneralTermsFooter}
        Reader_LegalNotices={translationsMap.Reader_LegalNotices}
        Reader_ClickServiceLevelTerms={
          translationsMap.Reader_ClickServiceLevelTerms
        }
        Reader_Patent={translationsMap.Reader_Patent}
        Reader_OtherService={translationsMap.Reader_OtherService}
      ></Footer>
    </div>
  );
};

export default RpdLite;
